import gql from 'graphql-tag'

export default gql`
  query($locale: String!, $preview: Boolean!) {
    page: pagePaymentMethodsGuidesCollection(limit: 1, locale: $locale, preview: $preview) {
      items {
        title
        slug
      }
    }
  }`
